import { render } from "./ReservasView.vue?vue&type=template&id=dceb60ae"
import script from "./ReservasView.vue?vue&type=script&lang=js"
export * from "./ReservasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__